import { render, staticRenderFns } from "./ModalVnptCAConfirm.vue?vue&type=template&id=8facaf32&scoped=true"
import script from "./ModalVnptCAConfirm.vue?vue&type=script&lang=js"
export * from "./ModalVnptCAConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalVnptCAConfirm.vue?vue&type=style&index=0&id=8facaf32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8facaf32",
  null
  
)

export default component.exports